import React, { Fragment, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { Listbox, Transition } from "@headlessui/react";
import { SvgMiHumberger , PaperUpload2, PaperDownload2, svgBulkEdit} from "@routes/IconeSvg";

/**
 * @typedef {Object} Props
 * @property {string=} Placeholder
 * @property {Array<any>} dataSelected
 * @property {boolean=} noRespWidth
 * @property {(event: any) => void=} importList 
 * @property {(event: any) => void=} onExportClick
 * @property {(event: any) => void=} bulkEditList
 * @property {boolean=} denyBulkEdit
 * @property {boolean=} denyExportEmployeeInfo 
 * @property {boolean=} isInfoPersAndEmploiSalaryUnavailable 
 * @property {boolean=} canCreateImportEmployees 
 */

/**
 *
 * @param {Props} props
 * @returns
 */
export default function EmployeeBatchTools(props) {
  const {
    Placeholder,
    dataSelected,
    noRespWidth,
    importList,
    onExportClick,
    bulkEditList,
    denyBulkEdit,
    denyExportEmployeeInfo,
    isInfoPersAndEmploiSalaryUnavailable,
    canCreateImportEmployees 
  } = props;

  const { t } = useTranslation("pages.employés.exportation");
  const [selected, setSelected] = useState([]);


  useEffect(() => {
    if (dataSelected) setSelected(dataSelected);
  }, [dataSelected]);


  return (
    <Listbox
      value={selected}
      onChange={setSelected}
      name="Emplacement"
      multiple
    >
      <div className="arh-relative arh-w-full">
        <Listbox.Button
          className={`arh-relative arh-flex arh-w-full arh-cursor-pointer arh-space-x-3 arh-whitespace-nowrap arh-rounded arh-border-0 arh-px-6 arh-py-3 arh-pr-8 arh-text-xs arh-text-white arh-text-left arh-font-poppins arh-border-greenColor hover:arh-bg-loaderGreen arh-font-normal arh-bg-greenColor arh-transition arh-duration-200 arh-ease-in`}
        >
          <span
            className="arh-pointer-events-none arh-block arh-h-full arh-w-[250px] arh-border-0 arh-bg-transparent arh-text-white arh-font-medium arh-text-xs">
            {Placeholder}
          </span>
          <i>
            {<SvgMiHumberger fill="#FFFFFF" />}
          </i>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="arh-transition arh-ease-in arh-duration-100"
          leaveFrom="arh-opacity-100"
          leaveTo="arh-opacity-0"
        >
          <Listbox.Options
            className={`arh-absolute arh-z-20 arh-right-0 arh-w-[calc(100vw-25.688rem)] arh-mt-3 arh-overflow-y-auto arh-overflow-x-hidden arh-rounded arh-bg-white arh-text-xs arh-shadow-xs ${noRespWidth ? " !arh-w-full" : ""
            }`}
          >
            <div className="arh-grid arh-grid-flow-col arh-grid-rows-1 arh-gap-3 arh-p-10">
              <div className="arh-w-[90%] arh-space-y-4">
                <div className={`arh-flex arh-space-x-4 ${!canCreateImportEmployees && "arh-opacity-65"}`}>
                  <div>{PaperUpload2()}</div>
                  <button
                    className="arh-bg-transparent arh-border-0"
                    onClick={importList}
                  >
                    <span className="arh-block arh-font-poppins arh-font-medium arh-text-[15px] arh-text-darkColor arh-text-left hover:arh-text-black/50">
                      {t("Importer une liste")}
                    </span>
                    <span className="arh-block arh-font-poppins arh-font-medium arh-text-[13px] arh-text-[#667085] arh-text-left">
                      {t(
                        "Pour ajouter plusieurs employés d'un seul coup à l'aide de notre gabarit Excel"
                      )}
                    </span>
                  </button>
                </div>
              </div>
              <div className="arh-w-[90%] arh-space-y-4">
                  <div className={`arh-flex arh-space-x-4 ${denyExportEmployeeInfo && "arh-opacity-65"}`}>
                  <div>{PaperDownload2()}</div>
                  <button
                    className="arh-bg-transparent arh-border-0"
                    onClick={onExportClick}
                  >
                    <span className="arh-block arh-font-poppins arh-font-medium arh-text-[15px] arh-text-darkColor arh-text-left hover:arh-text-black/50 ">
                      {t("Exporter une liste")}
                    </span>
                    <span className="arh-block arh-font-poppins arh-font-medium arh-text-[13px] arh-text-[#667085] arh-text-left">
                      {t(
                        "Pour exporter toutes les données présentes dans les dossiers des employés dans un fichier Excel"
                      )}
                    </span>
                  </button>
                </div>
              </div>
              <div className="arh-w-[90%] arh-space-y-4">
                <div className={`arh-flex arh-space-x-4 ${(isInfoPersAndEmploiSalaryUnavailable  || denyBulkEdit) && "arh-opacity-65"}`}>
                  <div>{svgBulkEdit()}</div>
                  <button
                    className="arh-bg-transparent arh-border-0"
                    onClick={bulkEditList}
                  >
                    <span className="arh-block arh-font-poppins arh-font-medium arh-text-[15px] arh-text-darkColor arh-text-left hover:arh-text-black/50">
                      {t("Modifications multiples")}
                    </span>
                    <span className="arh-block arh-font-poppins arh-font-medium arh-text-[13px] arh-text-[#667085] arh-text-left">
                      {t(
                        "Pour modifier massivement certaines informations aux dossiers des employés, pour éviter de le faire un à la fois"
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
}
